import { QueryClient } from "@tanstack/react-query"

// export const MEDUSA_BACKEND_URL = __BACKEND_URL__ ?? "https://admin.beautobe.com"
export const MEDUSA_BACKEND_URL = import.meta.env.VITE_MEDUSA_BACKEND_URL

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 90000,
      retry: 1,
    },
  },
})
